export const MAP_TOGGLE_CATEGORY = 'MAP_TOGGLE_CATEGORY'
export const MAP_SET_ALL_CATEGORIES = 'MAP_SET_ALL_CATEGORIES'
export const MAP_SELECT_PLACE = 'MAP_SELECT_PLACE'
